<div>
  <div
    class="message-container"
    *ngIf="resident?.deactivationReason === DeactivationReason.SelfPayer">
    <p>
      <b>
        Das Bewohnerkonto für
        {{ resident.getName({ withGender: true }) }} ist vorübergehende
        gesperrt.
      </b>
      <br />
    </p>
    <p>
      Hinweis: Eine Überweisung direkt von Angehörigen, Betreuer:innen oder
      Bewohner:innen ist nicht möglich.
    </p>
    <p>
      Wir bieten Zahlungen ausschließlich über das Verwahrgeldkonto (über die
      Einrichtung), oder über ein direktes Sepa-Lastschriftmandat auf ein
      privates Konto an. Bitte haben Sie Verständnis dafür, dass unser Service
      <b>keine private Zahlung auf Rechnung</b>
      vorsieht.
    </p>
  </div>
  <div
    class="message-container"
    *ngIf="resident?.deactivationReason === DeactivationReason.BurstSepa">
    <p>
      <b>
        Das Bewohnerkonto für
        {{ resident.getName({ withGender: true }) }} ist vorübergehende gesperrt
      </b>
    </p>
    <p>
      Grund für diese Maßnahme ist, dass eine SEPA-Lastschrift nicht erfolgreich
      durchgeführt werden konnte. Der entsprechende Betrag ist daher
      möglicherweise noch offen.
    </p>
    <p>
      Um die Sperrung aufzuheben und das Bewohnerkonto wieder zu aktivieren,
      bitten wir Sie außerdem um eine Klärung, wie die zukünftigen Zahlungen
      erfolgen sollen.
    </p>
    <p>
      Bitte kontaktieren Sie uns unter 030 403 6607-14 oder
      buchhaltung&#64;bringliesel.de, um die weiteren Schritte zu besprechen.
    </p>
  </div>
  <div
    class="message-container"
    *ngIf="resident?.deactivationReason === DeactivationReason.OpenInvoice">
    <p>
      <b>
        Das Bewohnerkonto für
        {{ resident.getName({ withGender: true }) }} ist vorübergehende gesperrt
      </b>
    </p>
    <p>
      Grund für diese Maßnahme ist eine offene Rechnung - siehe
      <u
        class="history-link"
        (click)="goToPage(resident.fname, resident.lname)">
        Bestellhistorie
      </u>
      .
    </p>
    <p>Wir bitten Sie, den ausstehenden Betrag umgehend zu überweisen.</p>
    <p>
      Sobald der Zahlungseingang verbucht wurde, wird das Bewohnerkonto direkt
      wieder freigeschaltet.
    </p>
  </div>
  <div
    class="message-container"
    *ngIf="
      !resident?.deactivationReason ||
      resident?.deactivationReason === DeactivationReason.Other
    ">
    <p>
      Leider kann für
      {{ resident.getName({ withGender: true }) }} aktuell nicht bestellt
      werden, da es offene Rechnungen gibt. Alle Rechnungen finden Sie in der
      <u
        class="history-link"
        (click)="goToPage(resident.fname, resident.lname)">
        Bestellhistorie
      </u>
      .
      <br />
      <br />
    </p>
    <p>Melden Sie sich dazu auch gerne direkt bei uns unter 030 403 6607-14</p>
  </div>
  <div
    class="message-container"
    *ngIf="
      resident?.deactivationReason === DeactivationReason.ConnextUnflagged
    ">
    <p>
      <b>
        Das Bewohnerkonto für
        {{ resident.getName({ withGender: true }) }} ist gesperrt.
      </b>
      <br />
    </p>
    <p>
      Grund für diese Maßnahme ist, dass bei dieser Person in
      {{ resident.partnerId | partnerCopyName }}
      das BringLiesel Merkmal entfernt wurde.
    </p>
    <p>
      Da allerdings für diese Person noch eine offene Rechnung im System
      existiert, kann das Bewohnerkonto noch nicht vollständig gelöscht werden.
      Sobald die Zahlung erfolgt ist, wird dieses Bewohnerkonto automatisch bei
      BringLiesel gelöscht.
      <br />
      <br />
      Sie müssen keine weiteren Schritte unternehmen.
    </p>
  </div>
</div>
